export default Object.freeze({
  ST5: 1,
  ST6: 2,
  ST34: 3,
  ST40: 4,
  ST43: 5,
  ST49: 6,
  ST51: 7,
  ST61_63: 8,
  ST44: 9,
  ST36: 10,
  ST42_1: 11,
  ST42_2: 12,
  ST54: 13,
  ST55: 14,
  ST78: 15,
  ST85: 16,
  ST86: 17,
})
